import AnnonceItem from "pages/Annonces/components/AnnonceItem";
import PaginationComponent from "pages/Dashboard/components/Paginations";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowCircleLeft, FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Col, Container, Row, Spinner } from "reactstrap";
import { getAll, setCurrentPage } from "store/slices/annonceSlice";

const MyAnnouncement = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { annonces, totalItems, totalPages, currentPage, fetchLoading } =
    useSelector((state) => state.Annonce);

  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Recherche :", searchValue);
    if (currentPage === 1) {
      dispatch(
        getAll({
          page: 1,
          searchValue: searchValue,
        })
      );
    } else {
      dispatch(setCurrentPage(1));
    }
  };

  useEffect(() => {
    dispatch(
      getAll({
        page: currentPage,
        searchValue: searchValue,
      })
    ).then(() => { });
  }, [currentPage]);

  return (
    <>
      <div
        style={{
          maxWidth: "100%",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Container>
          <div className="page-title-box">
            <Row className="d-flex justify-content-center align-items-center">
              <Col md="4">
                <Button
                  color="primary"
                  style={{ backgroundColor: "#157088", borderRadius: "5px" }}
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <FaArrowCircleLeft />
                  {"   "}
                  {t("announcement.returnToHome")}
                </Button>
              </Col>
              <Col
                md="4"
                className="d-flex justify-content-center font-size-20 font-weight-bolder"
                style={{ color: "#157088" }}
              >
                {t("announcement.seeMyAnnouncements")}
              </Col>
              <Col md="4" className="d-flex justify-content-end">
                <Button
                  style={{
                    color: "#157080",
                    borderColor: "#157080",
                    backgroundColor: "white",
                    borderRadius: "8px",
                  }}
                  outline
                  onClick={() => {
                    navigate("/annonces/publier");
                  }}
                >
                  {t("announcement.publishAnnouncement")}
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Row className="d-flex justify-content-center mt-3 mb-4">
        <Col md="5">
          <form className="app-search d-lg-block" onSubmit={handleSearch}>
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Recherchez un club, une annonce ou un essai..."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                style={{
                  borderRadius: 10,
                  backgroundColor: "#F3F8F9",
                  border: "1px solid #0B283980",
                }}
              />
              <span
                onClick={handleSearch}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <FaSearch size={15} style={{ color: "#0B2839" }} />
              </span>
            </div>
          </form>
        </Col>
      </Row>
      <Row>
        <div>
          {fetchLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spinner color="primary" />
            </div>
          ) : annonces && annonces.length > 0 ? (
            annonces.map((annonce, key) => (
              <AnnonceItem annonce={annonce} key={key}></AnnonceItem>
            ))
          ) : (
            <div style={{ marginTop: 20, textAlign: "center" }}>
              Aucun annonce trouvé.
            </div>
          )}
        </div>
        <PaginationComponent
          totalItems={totalItems}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        ></PaginationComponent>
      </Row>
    </>
  );
};

export default MyAnnouncement;
